// src/store/slices/areaSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Area }   from '../../types/notification'

import { areaService } from '../../services/api/area.service';

interface AreaState {
  areas: Area[];
  loading: boolean;
  error: string | null;
}

const initialState: AreaState = {
  areas: [],
  loading: false,
  error: null
};

export const fetchAreas = createAsyncThunk(
  'areas/fetchAll',
  async () => {
    const response = await areaService.getAll();
    return response.data;
  }
);

const areaSlice = createSlice({
  name: 'areas',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAreas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAreas.fulfilled, (state, action) => {
        state.areas = action.payload;
        state.loading = false;
      })
      .addCase(fetchAreas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch areas';
      });
  }
});

export default areaSlice.reducer;